import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { ValidateInput } from 'legacy/lut/library/validation'
import React, { useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { IForm } from 'core-components/classes/models/IForm'
import { Controller, ValidationStatus } from 'core-components/library/validation'

import { ApplyButton } from '../editors/ApplyButton'

import { TranslationKeys } from './enums/TranslationKeys'

import styles from './CommitmentDropEditor.module.scss'

interface IProps {
  item: IObjectAny
  onApply: (item: IForm) => void
  translation?: string
}

export const CommitmentDropEditor = ({ item, onApply, translation }: IProps) => {
  const [editItem, setEditItem] = useState<IObjectAny>(item)
  const [isChanged, setIsChanged] = useState(false)
  const [validationStatus, setValidationStatus] = useState(ValidationStatus.Invalid)

  const onChange = (newValue: string, fieldName: string) => {
    setEditItem({ ...editItem, [fieldName]: newValue })
    !isChanged && setIsChanged(true)
  }

  return (
    <div className={styles.root}>
      <Controller
        onValidationStatusChange={({ status: newStatus }) => {
          newStatus !== 'WIP' && setValidationStatus(newStatus)
        }}
      >
        <WidgetHeader>{TranslationKeys.CommentDialogTitle}</WidgetHeader>
        <div className={styles.desc}>
          <Translation text={TranslationKeys.CommentDialogDescription} />
        </div>
        <ValidateInput
          classes={{
            validatorClasses: {
              root: styles.input,
            },
          }}
          label="Comment *"
          type="text"
          value={editItem['Comment'] || ''}
          onChange={(value: string) => onChange(value, 'Comment')}
          checkFn={(value) => ValidationHelper.checkString(value, 'Please, enter a comment')}
          field={'Comment'}
          translation={translation || 'partnercommitment-comment'}
        />
      </Controller>

      <div className={styles.buttonLine}>
        <ApplyButton
          className={styles.button}
          disabled={!isChanged || validationStatus !== ValidationStatus.Valid}
          onClick={async () => {
            setIsChanged(false)
            onApply(editItem)
          }}
        />
      </div>
    </div>
  )
}
